/**
 * Header.js
 * Header component
 *
 * @class   ProgressBar
 * @author  Robert Sahm
 *
 */

import React from 'react';
import TextField from 'components/forms/text-field/TextField';
import Paper from 'components/paper/Paper';

const resetTimeout = 500;

export default React.createClass({

	displayName: 'ProgressBar',

	propTypes: {
		percentComplete: React.PropTypes.number
	},

	getDefaultProps() {
		return {
			minimum: 0.1,
			easing: 'ease',
			positionUsing: 'translate3d',
			speed: 175,
			trickle: true,
    		trickleRate: 0.02,
    		trickleSpeed: 300
		};
	},

	getInitialState() {
		return {
			started: false,
			show: false,
			percent: 0
		};
	},

	componentWillMount() {
		if(this.props.percentComplete) {
			this.setState({ percent: this.props.percentComplete });
		}
	},

	render() {

		let {
			speed,
			easing,
		} = this.props;

		return (
			<div className="lui-progress-bar">
				<div className="lui-progress-bar-wrap">
					<div 
						ref="bar"
						className="lui-progress-bar-inner"
						style={this._barPositionCSS(this.state.percent, speed, easing)} >
					</div>
				</div>
			</div>
		);
	},


	toPercent(number) {
		if(!this.state.started || !this.state.show) {
			this.setState({
				started: true,
				show: true
			});
		}
		this.setState({ 
			percent: number
		});
	},

	start() {
		this.setState({ 
			started: true,
			show: true
		});

		this.interval = setInterval(function() {
			this._trickle();
		}.bind(this), this.props.trickleSpeed);
	},

	done() {
		this.setState({ 
			started: false,
			percent: 100
		});

		clearInterval(this.interval);

		setTimeout(()=> {
			this.setState({
				show: false
			});
		}, resetTimeout);

		setTimeout(()=> {
			this.setState({
				percent: 0
			});
		}, resetTimeout * 2);
	},

	_clamp(n, min, max) {
		if (n < min) return min;
		if (n > max) return max;
		return n;
	},

	_trickle() {
		this._inc(Math.random() * this.props.trickleRate);
	},

	// Increments by a random amount.
	_inc(amount) {

		var n = this.state.percent / 100;

	    if (!this.state.started) {
	    	return this.start();
	    } else {
		    if (typeof amount !== 'number') {
		    	amount = (1 - n) * this._clamp(Math.random() * n, 0.1, 0.99);
		    };

		    amount = this._clamp(n + amount, 0.1, 0.99);

		    return this.setState({ percent: this._toBarPerc(amount) });
	    }
	},

	// (Internal) converts a percentage (`0..1`) to a bar translateX percentage (`-100%..0%`).
	_toBarPerc(n) {
		return parseInt(n * 100);
	},

	_barPositionCSS(n, speed, ease) {
		let barCSS;

		if (this.props.positionUsing === 'translate3d') {
			barCSS = {
				transform: 'translate3d(' + n + '%,0,0)',
			};
		} else if (this.props.positionUsing === 'translate') {
			barCSS = {
				transform: 'translate(' + n + '%,0)'
			};
		} else {
			barCSS = {
				marginLeft: n + '%'
			};
		};

		barCSS.transition = 'all ' + speed + 'ms ' + ease;
		barCSS.opacity = this.state.show ? 1 : 0;

		return barCSS;

	}
});


/** WEBPACK FOOTER **
 ** ./src/components/progress-bar/ProgressBar.js
 **/